import React, { useEffect } from 'react';

const Hero = () => {
  useEffect(() => {
    // Add glitch effect to elements with .glitch-image
    const glitchElements = document.querySelectorAll('.glitch-image');
    
    const glitchIntervals = glitchElements.forEach(element => {
      return setInterval(() => {
        const randomX = Math.random() * 10 - 5;
        const randomY = Math.random() * 10 - 5;
        element.style.transform = `translate(${randomX}px, ${randomY}px)`;
        
        setTimeout(() => {
          element.style.transform = 'translate(0, 0)';
        }, 100);
      }, 3000);
    });
    
    // Cleanup intervals on component unmount
    return () => {
      if (glitchIntervals && Array.isArray(glitchIntervals)) {
        glitchIntervals.forEach(interval => clearInterval(interval));
      }
    };
  }, []);

  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <h1>Oyun Geliştirme Çözümleri Uzmanı</h1>
          <h2>Güvenlik Sistemlerini Aşma & Premium Oyun Hizmetleri</h2>
          <p>Kinfhertix olarak oyun deneyiminizi geliştirmek için premium çözümler sunuyoruz. Uzman ekibimiz, en zorlu güvenlik sistemlerini analiz ederek tespit edilemeyen hile ve yazılım çözümleri geliştirmektedir.</p>
          <div className="cta-buttons">
            <a href="#expertise" className="btn primary">Hizmetlerimiz</a>
            <a href="#projects" className="btn secondary">Ürünlerimiz</a>
          </div>
        </div>
        <div className="hero-image">
          <div className="glitch-container">
            <div className="glitch-image"></div>
          </div>
        </div>
      </div>
      <div className="hero-overlay"></div>
    </section>
  );
};

export default Hero; 